<!-- dialog view -->


<div class="d-flex align-items-center justify-content-between drag-handle" cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h4 class="f-s-16 f-w-600 flex-fill" mat-dialog-title>{{  dataModule.name }}</h4>
  <button mat-icon-button mat-dialog-close>
      <i-tabler name="xbox-x"></i-tabler>
  </button>
</div>
<!-- <h2 mat-dialog-title cdkDragHandle>{{ dataModule.name }}</h2> -->
<mat-dialog-content class="mat-typography" >
  <p class="text-center">
    @if (contentType === 'application/pdf') {
      <iframe [src]="fileData" style="width: 100%;height: 60vh"></iframe>
    }
    @if (contentType !== 'application/pdf') {
      <img [src]="fileData" style="width: 100%"/>
    }
  </p>
</mat-dialog-content>
<!-- <mat-dialog-actions align="end">
  <button mat-flat-button class="bg-error text-white" mat-dialog-close>Close</button>
</mat-dialog-actions> -->
